export default `
@font-face {
  font-family: "Muli";
  src: url("https://web.glance-cdn.com/egc_pwa/ui/fonts/muli/Muli-Light.ttf");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Muli";
  src: url("https://web.glance-cdn.com/egc_pwa/ui/fonts/muli/Muli-Regular.ttf");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Muli";
  src: url("https://web.glance-cdn.com/egc_pwa/ui/fonts/muli/Muli-Bold.ttf");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Muli";
  src: url("https://web.glance-cdn.com/egc_pwa/ui/fonts/muli/Muli-Black.ttf");
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  min-height: 100%;
  font-family: "Muli", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #000;
  font-display: swap;
}
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}
`;
